import { TextAvatar } from "shared/ui/text-avatar/TextAvatar"

import "./styles/_team-member-chip.scss"

export interface TeamMemberChipViewProps {
  initials: string
  color: string
  role?: string
}

export function TeamMemberChipView({
  initials,
  color,
  role
}: TeamMemberChipViewProps) {
  return (
    <div className="team-member-chip">
      <TextAvatar
        initials={initials}
        color={color}
        className="text-avatar--small"
      />
      {role && <span className="team-member-chip__role">{role}</span>}
    </div>
  )
}
